import { isExperimentalFeatureEnabled } from '../domain/configuration';
import { addMonitoringMessage, monitor } from '../domain/internalMonitoring';
import { generateUUID, startsWith } from '../tools/utils';
export var LOCAL_STORAGE_KEY = 'datadog-browser-sdk-failed-send-beacon';
export function startFlushFailedSendBeacons() {
    if (!isExperimentalFeatureEnabled('lower-batch-size'))
        return;
    // delay the computation to prevent the SDK from blocking the main thread on init
    setTimeout(monitor(flushFailedSendBeacon));
}
export function addFailedSendBeacon(endpointType, size, reason) {
    if (!isExperimentalFeatureEnabled('lower-batch-size'))
        return;
    var failSendBeaconLog = {
        reason: reason,
        endpointType: endpointType,
        version: "4.10.4",
        connection: navigator.connection ? navigator.connection.effectiveType : undefined,
        onLine: navigator.onLine,
        size: size,
    };
    if (reason === 'before_unload' || reason === 'visibility_hidden') {
        window.localStorage.setItem("".concat(LOCAL_STORAGE_KEY, "-").concat(generateUUID()), JSON.stringify(failSendBeaconLog));
    }
    else {
        addMonitoringMessage('failed sendBeacon', failSendBeaconLog);
    }
}
function flushFailedSendBeacon() {
    var keys = Object.keys(localStorage);
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        if (startsWith(key, LOCAL_STORAGE_KEY)) {
            var value = localStorage.getItem(key);
            if (value) {
                addMonitoringMessage('failed sendBeacon', JSON.parse(value));
                window.localStorage.removeItem(key);
            }
        }
    }
}
//# sourceMappingURL=failedSendBeacon.js.map